const map = {
	"./1.png": 146,
	"./10.png": 88,
	"./11.png": 913,
	"./12.png": 770,
	"./13.png": 123,
	"./14.png": 180,
	"./15.png": 333,
	"./16.png": 654,
	"./17.png": 743,
	"./18.png": 192,
	"./19.png": 137,
	"./2.png": 457,
	"./20.png": 101,
	"./21.png": 212,
	"./22.png": 319,
	"./23.png": 742,
	"./24.png": 838,
	"./25.png": 328,
	"./26.png": 83,
	"./27.png": 874,
	"./28.png": 821,
	"./29.png": 788,
	"./3.png": 512,
	"./30.png": 562,
	"./31.png": 395,
	"./32.png": 416,
	"./33.png": 809,
	"./34.png": 246,
	"./35.png": 31,
	"./4.png": 679,
	"./5.png": 342,
	"./6.png": 93,
	"./7.png": 204,
	"./8.png": 443,
	"./9.png": 90
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 536;